import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowLeftCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM9.96963 8.96971C10.2625 8.67679 10.7374 8.67676 11.0303 8.96963C11.3232 9.2625 11.3232 9.73737 11.0304 10.0303L9.81084 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H9.81048L11.0303 13.9696C11.3232 14.2625 11.3232 14.7374 11.0304 15.0303C10.7375 15.3232 10.2626 15.3232 9.96971 15.0304L7.46971 12.5307C7.32905 12.3901 7.25002 12.1993 7.25 12.0004C7.24998 11.8015 7.32899 11.6108 7.46963 11.4701L9.96963 8.96971Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowLeftCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowLeftCircleFilledIcon;
